"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _AllowedIntents = _interopRequireDefault(require("./AllowedIntents"));

var _IntentsToPath;

var IntentsToPath = (_IntentsToPath = {}, (0, _defineProperty2.default)(_IntentsToPath, _AllowedIntents.default.LEAD_FLOWS, 'lead-flows'), (0, _defineProperty2.default)(_IntentsToPath, _AllowedIntents.default.MEETINGS, 'salesMeetings'), (0, _defineProperty2.default)(_IntentsToPath, _AllowedIntents.default.CONVERSATIONS, 'conversations'), (0, _defineProperty2.default)(_IntentsToPath, _AllowedIntents.default.DOCUMENTS, 'salesDocuments'), (0, _defineProperty2.default)(_IntentsToPath, _AllowedIntents.default.FORMS, 'marketingFreeForms'), (0, _defineProperty2.default)(_IntentsToPath, _AllowedIntents.default.SALES_FREE, 'salesFree'), (0, _defineProperty2.default)(_IntentsToPath, _AllowedIntents.default.SALES_O365, 'salesO365'), (0, _defineProperty2.default)(_IntentsToPath, _AllowedIntents.default.MARKETING_FREE_EMAIL, 'marketingFreeEmail'), (0, _defineProperty2.default)(_IntentsToPath, _AllowedIntents.default.SALES_VSTO, 'salesVsto'), (0, _defineProperty2.default)(_IntentsToPath, _AllowedIntents.default.MARKETING_ADS, 'marketingAds'), (0, _defineProperty2.default)(_IntentsToPath, _AllowedIntents.default.TRIAL, 'trial'), _IntentsToPath);
var _default = IntentsToPath;
exports.default = _default;
module.exports = exports.default;